import React from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import ApplicationDataProvider from "./features/app/ApplicationProvider";
import AuthorizationProvider from "./features/auth/AuthorizationProvider";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Loader from "./components/loader/Loader";
import { NuqsAdapter } from "nuqs/adapters/react-router";
import RootLayout from "./features/app/RootLayout";

const Main = React.lazy(() => import("./features/main"));
const ZoneDetail = React.lazy(() => import("./features/zone-detail"));

function App() {
  return (
    <AuthorizationProvider>
      <ApplicationDataProvider>
        <React.Suspense fallback={<Loader />}>
          <BrowserRouter>
            <NuqsAdapter>
              <Routes>
                <Route element={<RootLayout />}>
                  <Route path="/" index element={<Main />} />
                  <Route path="/delivery-zones/:zoneId" element={<ZoneDetail />} />
                </Route>
              </Routes>
            </NuqsAdapter>
          </BrowserRouter>
        </React.Suspense>
      </ApplicationDataProvider>
    </AuthorizationProvider>
  );
}

export default withAuthenticationRequired(App, {
  onRedirecting: () => <Loader />,
});
